import React from 'react';
import {
  Checkbox as MuiCheckbox,
  CheckboxProps as MuiCheckboxProps,
} from '@mui/material';
import CheckboxCheckedIcon from "../../../components/icons/checkboxCheckedIcon";
import CheckboxIndeterminateIcon from "../../../components/icons/checkboxIndeterminateIcon";
import CheckboxIcon from "../../../components/icons/checkboxIcon";

export type CheckboxProps = MuiCheckboxProps;

const Checkbox = function Checkbox({
  ...rest
}: CheckboxProps) {
  return (
    <MuiCheckbox icon={<CheckboxIcon/>} checkedIcon={<CheckboxCheckedIcon/>} indeterminateIcon={<CheckboxIndeterminateIcon/>} {...rest}/>
  );
}

export default Checkbox;